

<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-row>
        <a-col :span="22">
          <a-form-model :colon="false" :model="form" layout="inline" @keyup.enter.native="query">
            <a-form-model-item label="主要负责人：">
              <EmployeeSelector
                :single="true"
                @change="
                (arr) => {
                    if (arr.length > 0) {
                    user = arr[0];
                    } else {
                    user = {};
                    }
                }
                "
                :value="user.name ? [user] : []"
            >
                <a-button style="text-align:left;width: 180px">
                <span v-if='user.name'>{{user.name}}</span>
                <span v-else style="color: rgba(0, 0, 0, 0.35)"></span>
                </a-button>
            </EmployeeSelector>
            </a-form-model-item>
            <a-form-model-item label="负责部门：">
              <a-select
                show-search
                :filter-option="$selectFilterOption"
                v-model="form.deptId"
                style="width:150px"
                placeholder=""
              >
                <a-select-option
                  v-for="item in productionDepartmentList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{
                  item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-form-model>
        </a-col>
        <a-col :span="2">
          <div class="right" style="margin-top: 4px">
            <a-button
              v-if="$getPermission($route.path + '/add')"
              @click="$router.push($route.path + '/add')"
              type="primary"
            >创建公告</a-button>
          </div>
        </a-col>
      </a-row>

      <Padding />

      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="专属区域">
            <template slot-scope="text">{{ text.belongProvince }}-{{ text.belongCity }}-{{ text.district }}</template>
        </a-table-column>
        <a-table-column title="负责部门" data-index="deptName" align="center"></a-table-column>
        <a-table-column title="主要负责人" data-index="chargeUserName" align="center"></a-table-column>
        <a-table-column title="商务对接人" data-index="businessUserName" align="center"></a-table-column>
        <a-table-column title="技术对接人" data-index="technologyUserName" align="center"></a-table-column>
        <a-table-column title="历年合同金额(万元)" data-index="hisAmountSum" align="center"></a-table-column>
        <a-table-column title="当年合同金额(万元)" data-index="currentYearAmount" align="center"></a-table-column>
      </a-table>
    </a-card>
  </div>
</template>


<script>
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import organization from "@/mixins/organization";
import EmployeeSelector from "@/components/employee-selector";
function fetchList(params) {
  return request({
    url: "/market-service/scrm/exclusive/area/list",
    params
  });
}
export default {
  mixins: [watermark, organization],
  components: {
    EmployeeSelector,
  },
  data() {
    return {
      form: {},
      user: {},  
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      const { current, pageSize, form } = this;
      this.loading = true;
      fetchList({
        pageNum: current,
        pageSize: pageSize,
        ...form,
        chargeUserId: this.user.userId,
      })
        .then(res => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.user = {}
      this.getList();
    },

    preview(text) {
      this.$router.push(this.$route.path + "/detail?id=" + text.id);
    },
    edit(text) {
      this.$router.push(this.$route.path + "/edit?id=" + text.id);
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({
            id: text.id
          }).then(() => {
            that.getList();
          });
        }
      });
    }
  }
};
</script>